/** Mirrors `backend/functions/src/shared/daily-cards-experiment-policy.ts` and the rn-app model. */

export const DAILY_CARDS_EXPERIMENT_ID = "dailyCards";
export const DAILY_CARDS_CONTROL_VARIANT = "control";

export interface DailyCardsVariantOverrides {
  numberOfCardsPerBatch?: number;
  secondsToReleaseNewCard?: number;
}

/** RTDB `abTesting/definitions/dailyCards`, parsed. */
export interface DailyCardsExperimentConfig {
  /** Kill switch: false means every deck uses the base constants. */
  enabled: boolean;
  /** Epoch ms; enrolment (server-side) starts here. Informational on the client. */
  startedAt: number | null;
  /** Variant name -> deck allowance overrides; a missing variant means base constants. */
  variants: Record<string, DailyCardsVariantOverrides>;
}

/** RTDB `abTesting/assignments/{uid}/dailyCards`, written by Cloud Functions only. */
export interface DailyCardsAssignment {
  variant: string;
  assignedAt: number;
  source: "signup";
  cohortStartedAt: number | null;
  /** Adopted the partner's variant at coupling, before the first swipe. */
  inheritedFrom?: string;
  previousVariant?: string;
  reassignedAt?: number;
  /** Dropped from the read-out; the variant still applies to this user. */
  excludedReason?: "partnerUnassigned" | "coupledAfterPlay";
  excludedAt?: number;
}

/** What the deck builder actually uses; `variant` is null when the experiment is not in effect. */
export interface DeckAllowance {
  numberOfCardsPerBatch?: number;
  secondsToReleaseNewCard?: number;
  variant: string | null;
}
